import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const ItemBlock = styled.div`
  padding: 16px 8px;

  @media (min-width: 768px) {
    padding: 16px 8px 24px 8px;
  }

  @media (min-width: 1024px) {
    padding: 24px 40px;
  }

  &:not(:first-of-type) {
    border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  }
`

const ItemIngredient = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  h2 {
    margin-left: 16px;
  }

  img {
    border-radius: 4px;
  }
`

const ItemIconLeft = styled.img`
  width: 69px;
  height: 46px;

  @media (min-width: ${theme.mediaqueries.small}) {
    width: 85px;
    height: 57px;
  }

  @media (min-width: ${theme.mediaqueries.medium}) {
    width: 100px;
    height: 67px;
  }
`

const ItemContext = styled.div`
  margin: 16px 16px 0 16px;

  @media (min-width: 768px) {
    margin: 24px 24px 0 24px;
  }
`

const BenefitBox = styled(Box)`
  &:not(:last-of-type) {
    margin-bottom: 24px;
  }
`

const Complex = styled.div`
  width: 100%;
`

const HeaderContent = styled.div`
  border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  border-radius: 4px 4px 0 0;
  background-color: ${theme.wild.color.nova.base.solid[20]};
  width: 100%;
  padding: 16px;
  text-align: center;

  > p {
    display: none;

    @media (min-width: ${theme.mediaqueries.small}) {
      display: block;
    }
  }
`

const BodyContent = styled.div`
  border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  border-top: none;
  border-radius: 0 0 4px 4px;
  width: 100%;
  margin-bottom: 32px;

  @media (min-width: 768px) {
    margin-bottom: 40px;
  }
`

const BottomContent = styled.div`
  width: 100%;
  border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
  border-top: none;
  border-radius: 0 0 4px 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const IngredientLeft = styled.div`
  display: block;
  padding: 16px 8px;
  width: 50%;
  text-align: center;
  border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
`

const IngredientRight = styled.div`
  display: block;
  padding: 16px 8px;
  width: calc(50% - 1px);
  text-align: center;
`

const SpaceBlock = styled.div`
  height: 1px;
  width: 100%;
  display: block;
  background: ${theme.wild.color.nova.transparency.black[20]};
`

const IngredientBottomSection = ({ data, index, totalLength }) => {
  const number = index % 2
  return (
    <>
      {number === 0 && (
        <IngredientLeft>
          <TextElementNova
            className="Body-10-Dia-Normal text-nova-base-black"
            text={data}
          />
        </IngredientLeft>
      )}

      {number !== 0 && (
        <>
          <IngredientRight>
            <TextElementNova
              className="Body-10-Dia-Normal text-nova-base-black"
              text={data}
            />
          </IngredientRight>

          {index !== totalLength && <SpaceBlock />}
        </>
      )}
    </>
  )
}

const IngredientSection = ({ name, image, description }) => {
  return (
    <ItemBlock>
      <div>
        <ItemIngredient>
          <ItemIconLeft srcSet={`${image}&w=112`} />

          <TextElementNova
            element="h2"
            className="Body-20-Dia-Normal text-nova-base-black"
            text={name}
          />
        </ItemIngredient>
      </div>

      <ItemContext>
        <BenefitBox>
          <TextElementNova
            className="Body-10-Dia-Normal text-nova-base-black"
            text={description}
          />
        </BenefitBox>
      </ItemContext>
    </ItemBlock>
  )
}

const IngredientContent = (content) => {
  return (
    <>
      <Complex>
        {content.complex && (
          <>
            <HeaderContent>
              <TextElementNova
                element="h2"
                className="Body-30-Dia-Strong text-nova-base-black"
                text={content.complex.title}
              />

              <TextElementNova
                className="Body-20-Dia-Normal text-nova-base-black"
                text={content.complex.description}
              />
            </HeaderContent>

            <BodyContent>
              {content.complex.list.map((data, index) => (
                <IngredientSection
                  {...data}
                  key={`IndgredientContentComplex${index}`}
                />
              ))}
            </BodyContent>
          </>
        )}

        {content.keyActives && (
          <>
            <HeaderContent>
              <TextElementNova
                element="h2"
                className="Body-20-Dia-Strong text-nova-base-black"
                text={content.keyActives.title}
              />
            </HeaderContent>

            <BodyContent>
              {content.keyActives.list.map((data, index) => (
                <IngredientSection
                  {...data}
                  key={`IngredientContentKeyActives${index}`}
                />
              ))}
            </BodyContent>
          </>
        )}

        {content.ingredients && (
          <>
            <HeaderContent>
              <TextElementNova
                element="h2"
                className="Body-20-Dia-Strong text-nova-base-black"
                text={content.ingredients.title}
              />
            </HeaderContent>

            <BottomContent>
              {content.ingredients.list.map((data, index) => {
                let len = content.ingredients.list.length - 1

                return (
                  <IngredientBottomSection
                    data={data}
                    index={index}
                    totalLength={len}
                    key={`IngredientContentBottom${index}`}
                  />
                )
              })}
            </BottomContent>
          </>
        )}
      </Complex>
    </>
  )
}

export default IngredientContent
